import { apiRequest } from "./baseApi";
import { parseJsonOrThrow } from "./responseUtils";

/**
 * #574 / cortex-be#1114 — acknowledge an IPAWS bell notification.
 *
 * POST /api/v2/users/notifications/ipaws/:id/acknowledge
 *
 * The backend records acknowledged_at + acknowledged_via ("web") on the
 * caller's own notification-ledger row — the audit trail of which caregiver
 * saw the alert — and the item stops appearing in the bell feed.
 */
export const acknowledgeIpawsNotification = async (notificationId) => {
  const res = await apiRequest(
    `users/notifications/ipaws/${encodeURIComponent(notificationId)}/acknowledge`,
    { method: "POST", version: "v2" },
  );
  return parseJsonOrThrow(res, "IPAWS notification acknowledge");
};
